export default {"src":"/_next/static/media/winner_single.b119d32c.svg","height":203,"width":343,"blurWidth":0,"blurHeight":0};